import { useState, useEffect } from 'react';
import Pagination from 'react-bootstrap/Pagination';
import TransactionFilter from "./TransactionFilter/TransactionFilter";
import TransactionEntry from "./TransactionEntry/TransactionEntry";
import TransactionHeader from "./TransactionHeader/TransactionHeader";
import { useApi } from "../../Services/api";
import "./TransactionTable.css";
import backgroundImg from '../../Images/NoFoundImg.png';
function TransactionTable() {
  const [transactions, setTransactions] = useState([]);
  const [active, setActive] = useState(1);
  const [status, setStatus] = useState('all');
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalcanceled, setTotalcanceled] = useState(0);
  const [totalServiced, setTotalServiced] = useState(0);
  const [displayPages, setDisplayPages] = useState(0);
  const [search, setSearch] = useState('');
  const [startUtcTime, setStartUtcTime] = useState('');
  const [endUtcTime, setEndUtcTime] = useState('');
  const itemsPerPage = 10;
  const api = useApi();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const raw = await api.get(`Client/TransactionHistory?pageNumber=${active}&pageSize=${itemsPerPage}&search=${search}&startUtcTime=${startUtcTime}&endUtcTime=${endUtcTime}&pStatus=${status}`)
        const data = raw.data;
        setTransactions(data.list);
        setTotalPages(data.TotalPages);
        let calculatedPages;
        if (status === "all") {
          calculatedPages = data.TotalPages;
          setDisplayPages(data.TotalPages);
        } else if (status === "1") {
          calculatedPages = Math.ceil(data.totalServiced / itemsPerPage);
          setDisplayPages(Math.ceil(data.totalServiced / itemsPerPage));
        } else {
          calculatedPages = Math.ceil(data.totalCanceled / itemsPerPage);
          setDisplayPages(Math.ceil(data.totalCanceled / itemsPerPage));
        }
        if (active > calculatedPages && calculatedPages > 0) {
          setActive(calculatedPages);
        }
        setTotalRecords(data.TotalRecords);
        setTotalcanceled(data.totalCanceled);
        setTotalServiced(data.totalServiced);
      } catch (error) {
        setTransactions([]);
        console.log('error:', error);
      }
    };
    fetchData();
  }, [active, search, startUtcTime, endUtcTime, status, itemsPerPage]);

  let items = [];
  for (let number = 1; number <= totalPages; number++) {
    items.push(
      <Pagination.Item key={number} active={number === active} onClick={() => setActive(number)}>
        {number}
      </Pagination.Item>
    );
  }

  const renderEmptyEntry = (key) => (
    <div key={key} className="table-entry empty-entry">
      <div>&nbsp;</div>
    </div>
  );

  return (
    <div className="transactions-table">
      <TransactionFilter
        setSearch={setSearch}
        setStartUtcTime={setStartUtcTime}
        setEndUtcTime={setEndUtcTime}
      />
      <TransactionHeader 
        setStatus={setStatus}
        totalRecords={totalRecords}
        totalcanceled={totalcanceled}
        totalServiced={totalServiced}
      />
      {((totalRecords !== 0) && 
      (<>
        <div className="table-body">
          {
            transactions?.map((transaction, index) => (
              transaction.empty ? renderEmptyEntry(index) : <TransactionEntry key={index} rawData={transaction} />
            ))
          } 
        </div>
        <div className="table-footer">
          {(status==="all" &&
            <>
              <div>Displaying {(active - 1) * itemsPerPage + 1}-{Math.min(active * itemsPerPage, totalRecords)} of {totalRecords}</div>
            </>)
          }
          {(status==="1" &&
            <>
              <div>Displaying {(active - 1) * itemsPerPage + 1}-{Math.min(active * itemsPerPage, totalServiced)} of {totalServiced}</div>

            </>)
          }
          {(status==="2" &&
            <>
              <div>Displaying {(active - 1) * itemsPerPage + 1}-{Math.min(active * itemsPerPage, totalcanceled)} of {totalcanceled}</div>
            </>)
          }
          <div className="pagination">
            <div>
              {`${active}-${totalPages} `}&nbsp;
            </div>
            <Pagination size="sm">
              {(active > 1) ? <Pagination.Prev onClick={() => setActive(active - 1)} /> : <Pagination.Prev disabled />}
              {(active < totalPages) ? <Pagination.Next onClick={() => setActive(active + 1)} /> : <Pagination.Next disabled />}
            </Pagination>
          </div>
        </div> 
      </>)) || (
        <div className="empty-transactions">
          <img src={backgroundImg} alt="backgroundImg" ></img>
          <h5 className="no-transactions">No transactions found</h5>
          <p>Place a call, and they will show up here</p>
        </div>
      )
      }

    </div>
  );
}

export default TransactionTable;
